export const USER_MESSAGE_TYPES = {
  ZERO_STATE: 'ZERO_STATE',
  UPPER_MESSAGE: 'UPPER_MESSAGE',
  POP_UP: 'POP_UP',
  USER_MESSAGE: 'USER_MESSAGE',
};
